import React from "react";
import { createRoot } from "react-dom/client";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./styles/react/app.scss";
import GeneratorPageTemplatesWrapper from "./page/SecondScreen/generatorPageTemplatesWrapper";
import Wrapper from "./components/wrapper";
require("bootstrap");

let a = window.location.toString().includes("/entry/");

let base =
  window.location.pathname.slice(0, 18) === "/qr-code-generator"
    ? window.location.pathname.slice(0, 18)
    : window.location.pathname.slice(0, 21);

const root = createRoot(document.getElementById("root"));
const templateGeneratorPageBlock = document.getElementById("templateGeneratorPageBlockRoot");
let templateGeneratorPageBlockRoot = null;
if (templateGeneratorPageBlock) {
  templateGeneratorPageBlockRoot = createRoot(templateGeneratorPageBlock);
}

if (templateGeneratorPageBlockRoot) {
  const type = templateGeneratorPageBlock.dataset.type;
  templateGeneratorPageBlockRoot.render(
    <GeneratorPageTemplatesWrapper type={type} />
  );
}

root.render(
  <BrowserRouter basename={!a ? base : ""}>
    <Provider store={store}>
      <Wrapper />
    </Provider>
  </BrowserRouter>
);
